import apiClient from './apiClient';
import { BillingDocument } from '../types/billing';

/**
 * Error thrown when billing API request fails
 */
export class BillingApiError extends Error {
  constructor(
    message: string,
    public readonly statusCode?: number,
  ) {
    super(message);
    this.name = 'BillingApiError';
  }
}

/**
 * Billing API Service
 *
 * Handles API calls for billing documents (invoices and proformas).
 */
export const billingApi = {
  /**
   * Get all billing documents for the current tenant
   *
   * @returns Array of billing documents sorted by issue date (newest first)
   * @throws BillingApiError with user-friendly message if request fails
   */
  getDocuments: async (): Promise<BillingDocument[]> => {
    try {
      const response = await apiClient.get<BillingDocument[]>('/billing/documents');
      return response.data;
    } catch (error: unknown) {
      const axiosError = error as { response?: { status?: number } };
      const status = axiosError.response?.status;

      if (status === 401) {
        throw new BillingApiError('Sesja wygasła. Zaloguj się ponownie.', 401);
      }
      if (status === 403) {
        throw new BillingApiError('Brak dostępu do dokumentów.', 403);
      }
      if (status === 429) {
        throw new BillingApiError(
          'Zbyt wiele żądań. Poczekaj chwilę i spróbuj ponownie.',
          429,
        );
      }
      throw new BillingApiError(
        'Nie udało się załadować dokumentów. Spróbuj ponownie.',
        status,
      );
    }
  },
};
